import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { saveLastSeenProductRelease } from 'containers/NewRelease/actions'

import HelpMenu from 'components/pages/navigation/HelpMenu'

import { selectHelpMenuItems } from './selectors'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ saveLastSeenProductRelease }, dispatch)
const mapStateToProps = (state) => ({
  helpMenuItems: selectHelpMenuItems(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(HelpMenu)

export default withRouter(render)
